"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.depositReserveLiquidity = void 0;
const models_1 = require("../../../models");
const account_1 = require("../../../utils/account");
const depositReserveLiquidity = (connection, signers, instructions, cleanupInstructions, source, depositAmount, wallet, detailReserve, lendingProgramID, lendingMarketAuthority, destinationCollateralAccount) => __awaiter(void 0, void 0, void 0, function* () {
    const reserve = detailReserve.info;
    const reserveAddress = detailReserve.pubkey;
    // user from account
    if (destinationCollateralAccount == undefined) {
        destinationCollateralAccount = yield (0, account_1.getOrCreateAssociatedTokenAccount)(connection, instructions, wallet, reserve.collateral.mintPubkey, wallet);
    }
    instructions.push((0, models_1.depositReserveLiquidityInstruction)(depositAmount, source, destinationCollateralAccount, reserveAddress, reserve.liquidity.supplyPubkey, reserve.collateral.mintPubkey, reserve.lendingMarket, lendingMarketAuthority, wallet, lendingProgramID));
    return destinationCollateralAccount;
});
exports.depositReserveLiquidity = depositReserveLiquidity;
